"use client";

import dynamic from "next/dynamic";

const PrequalForm = dynamic(() => import("@/components/onboarding/PrequalForm"), {
  ssr: false,
});

export default PrequalForm;
